cv.ProjectBehavior = Marionette.Behavior.extend({
  // you can set default options
  // just like you can in your Backbone Models
  // they will be overriden if you pass in an option with the same key
  defaults: {
  },

  // behaviors have events that are bound to the views DOM
  events: {
    'click .cv-manage-page' : 'editPage'
  },

  initialize: function(){
    this.listenTo(vent, 'public:initialized', function(){
      this.project_id = 0;
      if($('#cv-project-id').length > 0){
        this.page_type = 'project';
        this.project_id = $('#cv-project-id').val();
      }
    }, this);

    this.listenTo(vent, 'project:refresh', this.updateProject, this);

    console.log('ProjectBehavior initialized');
  },

  editPage: function(e){
    e.preventDefault();

    if(cv.PRELOADED.logged_in == true){
      cv.adminRouter.navigate("page", { trigger: true });
    }
  },

  updateProject: function(){
    if(this.project_id != 0){
      $.ajax({
        url: cv.api_path + '/projects/' + this.project_id,
        dataType: "json",
        type: 'get',
        success: _.bind(function(response){
          // Update the profile photo
          if(response.data.user.photo_path != cv.project.get('user.photo_path')){
            // Fundraiser profile photo
              var $replace_p = this.$('#details .profile-photo').clone();
        
              $replace_p.attr('data-src', cv.photo({
                photo_path : response.data.user.photo_path,
                photo_default : cv.campaign.get('default_fundraiser_photo'),
                url_only : true,
                transforms : {
                  fit : 'crop'
                }
              }));
              
              this.$('#details .profile-photo').replaceWith($replace_p);
      
              setTimeout(_.bind(function(){
                imgix.fluid(this.$('#details .profile-photo').get(0), {
                  updateOnResizeDown: false,
                  pixelStep: 5,
                  autoInsertCSSBestPractices: true
                });
              }, this), 50);
          }

          // Update name
          this.$('#details .profile-name').text(response.data.display_name);
          document.title = response.data.display_name;

          // Update URL
          this.$('#details .profile-url a').attr('href', '//' + response.data.url);
          this.$('#details .profile-url a').html(response.data.url);

          // Update the appeal
          this.$('#main .post-entry').html(response.data.appeal);

          // Update any share URLs
          this.$('.cv-share').attr('data-url', response.data.url);

          // Update any donation URLs
          this.$('.cv-donate').attr('data-url', response.data.url);

          // Update the stats
          this.$('.cv-funds-needed').text(cv.formatMoney({
            show_sign : true,
            amount : response.data.funds_needed,
            currency_code : cv.campaign.get('currency_code'),
            decimal_places : 0
          }));
          this.$('.cv-funds-raised').text(cv.formatMoney({
            show_sign : true,
            amount : response.data.funds_raised,
            currency_code : cv.campaign.get('currency_code'),
            decimal_places : 0
          }));

          // Progress bar stuff
          var percent_progress = Math.round(response.data.funds_raised/response.data.funds_needed * 100);
          if(percent_progress > 100){
            percent_progress = 100;
          }
          this.$('#project-stats .progress-fill').css('width', percent_progress + '%');
          this.$('#project-stats .progress-tooltip').text(' ' + percent_progress + '%');
        }, this),
        error: _.bind(function(data){
        }, this)
      });
    }
  }
});